/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Passkey_ConfiguredInputs */



/**
* | output |
* | --- |
* | "Face ID, Touch ID, or security key" |
*
* @param {Profile_Passkey_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_passkey_configured = /** @type {((inputs?: Profile_Passkey_ConfiguredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Passkey_ConfiguredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Face ID, Touch ID, ou clé de sécurité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Face ID, Touch ID o llave de seguridad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Face ID, Touch ID, ou chave de segurança")
	if (locale === "it") return /** @type {LocalizedString} */ ("Face ID, Touch ID, o chiave di sicurezza")
	return /** @type {LocalizedString} */ ("Face ID, Touch ID, or security key")
});